import SanitizedHtml from '../../SanitizedHtml/SanitizedHtml';
import './CmsHeader.css';
import { CmsMeta } from '../cmsMeta';

const lightToDarkCategoryColorMap: Record<string, string> = {
	'#e1f4ff': '#73cbff',
	'#e8eefe': '#8cabff',
	'#ede8fe': '#b298fe',
	'#fae8fe': '#e988fc',
	'#fee8ef': '#ff80a6',
	'#fee0d4': '#ff956b',
	'#fdf1dc': '#ffc766',
	'#fed4d4': '#a01515',
	'#ffee58': '#6c620b',
	'#fbf5c6': '#ffee58',
	'#fffbdc': '#ffee58',
	'#78e989': '#1e3a22',
	'#e4fbe7': '#78e989',
};

const CmsHeader = ({
	image,
	content,
	logoImage,
	badgeText = '',
	badgeColor,
}: {
	image: string;
	content: string;
	logoImage?: string;
	badgeText?: string;
	badgeColor?: string;
}) => {
	const colorMap = (bgColor: string): string => {
		if (!bgColor) return bgColor;
		const normalized = bgColor.trim().toLowerCase();
		const hexWithHash =
			normalized.startsWith('#') && normalized.length === 7
				? normalized
				: normalized.match(/^[0-9a-f]{6}$/)
					? `#${normalized}`
					: normalized;
		return lightToDarkCategoryColorMap[hexWithHash] || bgColor;
	};

	const badgeBackgroundColor = badgeColor ? colorMap(badgeColor) : undefined;
	const normalizedBadgeBackground = badgeBackgroundColor?.trim().toLowerCase();
	const isWhiteTextBackground = normalizedBadgeBackground === '#a01515';
	const badgeHtml = badgeText
		? `<div class="cms-header-badge" style="background-color: ${badgeBackgroundColor}${
				isWhiteTextBackground ? '; color: #ffffff' : ''
			}">${badgeText}</div>`
		: '';

	return (
		<div className="cms-header">
			<div className="banner">
				<img src={image} />

				{logoImage && <img className="banner-logo" src={logoImage} />}
			</div>
			<div className={`content-text ${badgeHtml ? 'with-badge' : ''}`}>
				<content-card>
					{content && <SanitizedHtml className="cms-header__content" html={badgeHtml + content} />}
				</content-card>
			</div>
		</div>
	);
};

export default CmsHeader;

export const cmsMeta: CmsMeta = {
	description:
		"The top of a campaign or brand page: a large picture, optionally with a brand logo over it, and a card of text below it that can carry a coloured badge. `content` takes simple html, usually an <h1> and a paragraph. `badgeColor` is one of the site's light category colours, such as #e4fbe7 or #fdf1dc, and the badge is drawn in its darker partner; leave it empty for the default.",
	example: [
		'CmsHeader',
		{
			image: 'https://cdn.ondio.com/assets/141f1768a23848c4a6688499d813148e.jpg',
			logoImage: 'https://cdn.ondio.com/assets/5a1a32678a3b4e4894b5cc0234ce5f40.png',
			badgeText: 'Leitz Hemmakontor',
			badgeColor: '#e4fbe7',
			content:
				'<h1>Ergonomi som passar hemma</h1><p>Leitz gör det enkelt att skapa ett hemmakontor som både känns bra och fungerar i vardagen.</p>',
		},
	],
};
